import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function ItalyNonDomTaxRegime() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.italy-non-dom-tax-regime.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/italy-non-dom-tax-regime"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/non-dom-tax-regim/italy-non-dom.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('qualify.title')}
                        blocks={[{ items: obj('qualify.items') }]}
                    />

                    <WhySection
                        title={tp('benefits.title')}
                        blocks={[{ items: obj('benefits.items') }]}
                    />

                    <WhySection
                        title={tp('uses.title')}
                        blocks={[{ items: obj('uses.items') }]}
                    />

                    <InfoBlocks
                        title={tp('example.title')}
                        blocks={obj('example.blocks')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
